import { render, staticRenderFns } from "./NeedToPayBlock.vue?vue&type=template&id=0428bf7a&scoped=true&"
import script from "./NeedToPayBlock.vue?vue&type=script&lang=js&"
export * from "./NeedToPayBlock.vue?vue&type=script&lang=js&"
import style0 from "./NeedToPayBlock.vue?vue&type=style&index=0&id=0428bf7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0428bf7a",
  null
  
)

export default component.exports